import React, { useState,useEffect } from 'react';
//组件
import { Image,Button,List,Input,Toast } from 'antd-mobile'
import {isBlank, checkPhone, isNotBlank} from "../../util/StringUtil";
import $axios from "../../request";

//样式
import {Container} from './style'
export default function WagesSubmitSucceed(props) {
    const [count, setCount] = useState(0);
    const [mobile, setMobile] = useState('');
    const [code, setCode] = useState('');

    useEffect(() => {

        // 定时器判断
        if (count === 0) {
            return;
        }
        const interval = setInterval(() => {
            setCount(() => count - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [count]);

    function handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        props.history.push(to)
    }


     function sendCode(){
        if (!checkPhone(mobile)) {
            return Toast.show('请输入正确的手机号');
        }
        setCount(59);
        let url = '/mobile/verification';
        $axios.postRequest(url,{mobile})
            .then((response) => {
                console.log(url, response);
                if (response.succeed) {
                    Toast.show('获取验证码成功');
                }else{
                    Toast.show('获取验证码失败');
                    setCount(0);
                }
            })
            .catch((error) => {
                console.log(url, error);
                Toast.show('获取验证码失败');
                setCount(0);

            });
    }

    function onSubmit(){
        if (!checkPhone(mobile)) {
            return Toast.show('请输入正确的手机号');
        }
        if (isBlank(code)) {
            return Toast.show('请输入验证码');
        }
        let url = '/mobile/login';
        //let url = '/login';
        $axios.postRequest(url,{mobile,code})
            .then((response) => {
                console.log(url, response);

                if (response.succeed) {
                    const token = response?.data?.user?.token
                    if(token){
                        Toast.show('登录成功');
                        $axios.setAuthToken(token);
                        console.log('props.history',props.history);
                        setTimeout(
                            () => {
                                props.history.goBack();
                            },
                            500
                        );
                        props.history.goBack();
                    }else{
                        Toast.show('登录失败');
                    }


                }else{

                }
            })
            .catch((error) => {
                console.log(url, error);
                Toast.show('登录失败');

            });
    }

    return (
        <Container >
            <div className='container'>
                <div className='blank'></div>
                <div className='content'>
                    <Image
                        width={60}
                        height={60}
                        fit='contain'
                        style={{ borderRadius: 8 }}
                        src={require("assets/images/logo60@3x.png")}

                    />


                    <List
                        style={{
                            '--prefix-width': '6em',
                        }}
                    >
                        <List.Item prefix=''>
                            <Input placeholder='请输入手机号' clearable value={mobile} onChange={(value) => setMobile(value)} />
                        </List.Item>
                        <List.Item prefix='' extra={<a onClick={() => {
                            sendCode()
                        }}
                        >{count ? `${count}s后重新获取` : '获取验证码'}</a>}>
                            <Input placeholder='请输入验证码' clearable  value={code} onChange={(value) => setCode(value)}/>
                        </List.Item>
                    </List>

                    <Button
                        className='button'
                        block
                            color='primary'
                            size='large'
                            onClick={() => {
                                onSubmit()
                            }}
                           >
                        登录
                    </Button>
                </div>

            </div>
        </Container>
    );
}
